var _a;
import { generateHooks } from "../generators/generator.hooks";
import { GENERATOR_PARAMS } from "./broker.constants";
export var useDetail = (_a = generateHooks(GENERATOR_PARAMS), _a.useDetail), useCount = _a.useCount, usePaged = _a.usePaged;
